import { hasEffectiveRole } from "../utils/roleAliases";

export const RISK_AND_OPP_MODULE_ADMIN = "RISK_AND_OPP_MODULE_ADMIN";
export const RISK_AND_OPP_DOFA_ADMIN = "RISK_AND_OPP_DOFA_ADMIN";
export const RISK_AND_OPP_STRATEGY_ADMIN = "RISK_AND_OPP_STRATEGY_ADMIN";
export const SERALOGIN_RISK_AND_OPP_ACCESS = "SERALOGIN_RISK_AND_OPP_ACCESS";

export const SERALOGIN_PROCESS_LEADER_BY_PROCESS = {
  1: "SERALOGIN_PROCESS_LEADER_ADMINISTRATIVE_MANAGEMENT",
  2: "SERALOGIN_PROCESS_LEADER_BIOMEDICAL_MANAGEMENT",
  3: "SERALOGIN_PROCESS_LEADER_COMMERCIAL_MANAGEMENT",
  4: "SERALOGIN_PROCESS_LEADER_HUMAN_RESOURCES_MANAGEMENT",
  5: "SERALOGIN_PROCESS_LEADER_HSQ_MANAGEMENT",
  6: "SERALOGIN_PROCESS_LEADER_MARKETING_AND_PROMOTION_MANAGEMENT",
  7: "SERALOGIN_PROCESS_LEADER_CUSTOMER_SERVICE_MANAGEMENT",
  8: "SERALOGIN_PROCESS_LEADER_FINANCIAL_AND_ACCOUNTING_MANAGEMENT",
  9: "SERALOGIN_PROCESS_LEADER_PHARMACEUTICAL_MANAGEMENT",
  10: "SERALOGIN_PROCESS_LEADER_MANAGEMENT_DIRECTION",
  11: "SERALOGIN_PROCESS_LEADER_FOREIGN_TRADE_DIRECTION",
  12: "SERALOGIN_PROCESS_LEADER_TECHNICAL_SUPPORT_DIRECTION",
  13: "SERALOGIN_PROCESS_LEADER_SAFETY_AND_HEALTH_AT_WORK",
  14: "SERALOGIN_PROCESS_LEADER_FOREIGN_TRADE_MANAGEMENT",
  15: "SERALOGIN_PROCESS_LEADER_CUSTOMER_SERVICE_PHARMADIA"
};

export const SERALOGIN_PROCESS_LEADER_ROLES = Object.values(
  SERALOGIN_PROCESS_LEADER_BY_PROCESS
);

export const isRiskAndOppAdmin = (roleList = []) =>
  hasEffectiveRole(roleList, RISK_AND_OPP_MODULE_ADMIN);

export const canManageRiskAndOppProcess = (roleList = [], processId) => {
  if (isRiskAndOppAdmin(roleList)) return true;
  const processLeaderRole =
    SERALOGIN_PROCESS_LEADER_BY_PROCESS[Number(processId)];
  return processLeaderRole
    ? hasEffectiveRole(roleList, processLeaderRole)
    : false;
};

export const canManageAnyRiskAndOppProcess = (roleList = []) =>
  isRiskAndOppAdmin(roleList) ||
  SERALOGIN_PROCESS_LEADER_ROLES.some((role) =>
    hasEffectiveRole(roleList, role)
  );

export const canManageDofaProcess = (roleList = [], processId) =>
  isRiskAndOppAdmin(roleList) ||
  hasEffectiveRole(roleList, RISK_AND_OPP_DOFA_ADMIN) ||
  canManageRiskAndOppProcess(roleList, processId);

export const canManageStrategyProcess = (roleList = [], processId) =>
  isRiskAndOppAdmin(roleList) ||
  hasEffectiveRole(roleList, RISK_AND_OPP_STRATEGY_ADMIN) ||
  canManageRiskAndOppProcess(roleList, processId);
